module.exports = __webpack_public_path__ + "static/media/book6.e00473b9.jpg";